import { useEffect, useState } from "react";
import { useGetHourlyOrderRegisterCountChar, } from "../../../Production/OrderArchive/Hook";
import { useGetHourlyStepCountChart,useGetOperatorStepCountChart} from './Hooks/index'
import dayjs from "dayjs";
import moment from "moment-jalaali";


const useHourlyContainer = () => {
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [processStepPoint, setProcessStepPoint] = useState({ key: 'ثبت سفارش', value: 1 });



  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : type === "year" 
          ? { name: "year", enum: 2 }
          : { name: "all", enum: 3}
    );
  };
  const { mutate: registerMutate, data: registerCountData } = useGetHourlyStepCountChart();
  const { mutate: CallOperatorStep, data: OperatorStepsData } = useGetOperatorStepCountChart();

  





  // tab filter
  const [datePicker, setDatePicker] = useState(dayjs());
  const [activeFilterType, setActiveFilterType] = useState(1);
  const [dateForSubmit, setDateForSubmit] = useState({
    year: 0,
    month: 0,
    day: 0,
  });
  /* ------------------------------- DatePicker ------------------------------- */
  const formatDatePicker = (chartFilter) => {
     if (chartFilter.name === "all") {
      return moment(datePicker).locale("en").format("jYYYY");
    }
    if (chartFilter.name === "year") {
      return moment(datePicker).locale("en").format("jYYYY");
    } else if (chartFilter.name === "mondth") {
      return moment(datePicker).locale("en").format("jYYYY/jMM");
    } else if (chartFilter.name === "day") {
      return moment(datePicker).locale("en").format("jYYYY/jMM/jDD");
    }
  };

  const dateSubmit = (splitDate, chartFilter) => {
    if (chartFilter.name === "all") {
      setDateForSubmit({
        year: 0,
        month: 0,
        day: 0,
      });
    }
   else if (chartFilter.name === "year") {
      setDateForSubmit({
        year: splitDate[0],
        month: 0,
        day: 0,
      });
    } else if (chartFilter.name === "mondth") {
      setDateForSubmit({
        year: splitDate[0],
        month: splitDate[1],
        day: 0,
      });
    } else if (chartFilter.name === "day") {
      setDateForSubmit({
        year: splitDate[0],
        month: splitDate[1],
        day: splitDate[2],
      });
    }
  };



  useEffect(() => {
    const dateSelect = formatDatePicker(chartFilter);
    const splitDate = dateSelect.split("/");
    dateSubmit(splitDate, chartFilter);

  }, [datePicker, chartFilter]);


  





  /* --------------------------------- Render --------------------------------- */
  useEffect(() => {
    if (activeFilterType === 1) {
      registerMutate({
        chartReportTiming: chartFilter.enum,
        ...dateForSubmit,
        processStepPoint: processStepPoint?.value || 1,
      });
 
  }
     else {
      CallOperatorStep({
        chartReportTiming: chartFilter.enum,
        ...dateForSubmit,
        processStepPoint: processStepPoint?.value || 1,
      });
    }
  }, [dateForSubmit, processStepPoint,activeFilterType]);





return {
  value: { chartFilter, registerCountData,OperatorStepsData, activeFilterType, datePicker, dateForSubmit },
  action: { tabHandler, setActiveFilterType, setDateForSubmit, setDatePicker, setProcessStepPoint },
};
};
export default useHourlyContainer;
